import App from '../../assets/js/app';

import SessionController from '../../assets/js/controllers/session';


export default class Header {

	static selector = 'header';

	#_page = null;

	#_username = null;

	constructor(container) {
		this.el = {
			container,
			anchors: container.querySelectorAll('a'),
			user: container.querySelector(`.${this.constructor.selector}__user`),
			logout: container.querySelector(`.${this.constructor.selector}__logout`)
		};

		this.addEventListeners();
	}

	get page() {
		return this.#_page;
	}

	set page(page) {
		this.#_page = page;
		for (const a of this.el.anchors) {
			a.classList[a.dataset.id === page ? 'add' : 'remove']('is-active');
		}
	}

	get username() {
		return this.#_username;
	}

	set username(username) {
		this.#_username = username;
		this.el.user.innerText = username || '';
	}

	#onLogoutClick = () => {
		SessionController.logout().then(() => App.open(App.page));
	};

	addEventListeners() {
		this.el.logout.addEventListener('click', this.#onLogoutClick);
	}

	removeEventListeners() {
		this.el.logout.removeEventListener('click', this.#onLogoutClick);
	}

}
